
<template>
  <div class="about">
    <div class="box">
      <div class="boxMain">
        <div>
          <el-image :src="require('./images/aboutImg.jpg')"></el-image>
        </div>
        <div class="aboutTxt">
          <div class="title" @click="usMe"> 这就是我们 </div>
          <div class="txtMain">
            <div class="itemTxt"> 北京淏睿科技，是一家商家服务公司，2010年6月在北京注册成立。 </div>
            <div class="itemTxt"> 致力于为商家提供数字化转型产品及运营服务，助力商家经营可持续增长，提高经营效率。</div>
            <div class="itemTxt"> 淏睿科技为商家提供电商零售、社区团购、商超生鲜、内容电商视频资质送审等数字化解决方案。</div>
            <div class="itemTxt">
              面对商家的定制化服务需求，全面支持商家定制各类个性化解决方案，为商家提供更多应用选择和更好服务。淏睿科技通过产品和服务，助力企业数字化升级，通过数字科技驱动商业革新，让商业变得更智慧！</div>
          </div>
        </div>
      </div>
    </div>

    <div class="serveBox">
      <div class="serveTitle"> 提供服务 </div>
      <div class="serveMain">

        <div class="serveItem">
          <div class="itemName"> 内容电商 </div>
          <div class="itemImg">
            <el-image :src="require('./images/itemImg01.png')"></el-image>
          </div>
        </div>

        <div class="serveItem">
          <div class="itemName"> 本地生活 </div>
          <div class="itemImg">
            <el-image :src="require('./images/itemImg02.png')"></el-image>
          </div>
        </div>

        <div class="serveItem">
          <div class="itemName"> 新零售 </div>
          <div class="itemImg">
            <el-image :src="require('./images/itemImg03.png')"></el-image>
          </div>
        </div>

      </div>
    </div>

    <div class="weBox" id="vital">
      <div class="weMain">
        <div class="weItemTitle"> 联系我们 </div>
        <div class="weItem"> 商家服务问题，选择北京淏睿科技 </div>
        <div class="weItem"> 联系方式：010-53670011 </div>
      </div>
      <div class="wxImg">
        <el-image :src="require('./images/footerImg.jpg')"></el-image>
      </div>
    </div>

  </div>
</template>

<script>
var VueScrollTo = require("vue-scrollto");
export default {
  name: "About",
  data() {
    return {
      scollVal: 0
    }
  },

  mounted() {
    console.log('mounted', this.$route)


    const { id } = this.$route.query
    this.changeFun(id)
  },

  watch: {
    scollVal: function (val) {
      console.log('watch', val)
      if (val * 1 > 0) {
        this.usMe('#vital')
      }
    }
  },

  methods: {
    usMe(id) {
      document.querySelector(id).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      })
    },

    changeFun(val) {
      console.log('changeFun', val)
      // console.log('onLoad --- scollVal', this.scollVal)
      this.$bus.$on('setSTop', (data) => {
        console.log('onLoading', data)
        // if(data*1 == 3){
        //   // this.usMe('#vital')
        this.scollVal = data * 1
        // }
      })
      if(val *1 == 2){
        this.usMe('#vital')
      }
    }
  }
};
</script>

<style lang='less' scoped>
.about {
  margin-top: 100px;

  .box {
    display: flex;
    align-items: center;
    padding: 80px 0 90px;
    background: #EEF3FF;

    .boxMain {
      margin: 0 150px;
      display: flex;
      align-items: center;
      width: 100%;

      .aboutTxt {
        width: 810px;
        margin-left: auto;

        .title {
          font-size: 45px;
          color: #333;
          margin-bottom: 40px;
        }

        .txtMain {
          .itemTxt {
            font-size: 20px;
            color: #4F4F4F;
            margin-bottom: 20px;
          }
        }
      }
    }
  }

  .serveBox {
    padding: 110px 0 120px;

    .serveTitle {
      font-size: 45px;
      color: #101010;
      margin-bottom: 70px;
      text-align: center;
    }

    .serveMain {
      margin: 0 150px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .serveItem {
        width: 527px;
        height: 342px;
        display: flex;
        align-items: center;
        background: #f9f9f9;
        padding: 50px 0 40px 0;
        border-radius: 10px;

        .itemName {
          font-size: 50px;
          color: 000;
          margin: 0 auto;
        }

        .itemImg {
          margin-left: auto;
          margin-right: 30px;
        }
      }
    }
  }

  .weBox {
    position: relative;
    width: 100%;
    height: 100%;

    .weMain {
      width: 100%;
      position: absolute;
      top: 0;
      z-index: 10;
      text-align: center;
      color: #fff;
      margin-top: 75px;

      .weItemTitle {
        font-size: 45px;
        margin-bottom: 62px;
      }

      .weItem {
        font-size: 40px;
        margin-bottom: 30px;
      }
    }

    .wxImg {
      width: 100%;
      height: 470px;

      .el-image {
        display: contents;
      }
    }
  }
}
</style>